import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { finalize } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { NotificationListModel } from '../../../../core/models/notification/notification-content-list.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-push-notifications',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './push-notifications.component.html',
  styleUrl: './push-notifications.component.scss',
})
export class PushNotificationsComponent {
  pushNotifications: NotificationListModel[] = [];
  totalPushNotifications: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes: number[] = [10, 25, 50, 100];
  currentPage: number = 1;
  pushNotificationListLoading: boolean = true;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getPushNotificationList(this.currentPage, this.pageSize);
  }

  getPushNotificationList(page: number, size: number): void {
    this.notificationService
      .notificationTemplate(page, size, 2)
      .pipe(
        finalize(() => {
          this.pushNotificationListLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.pushNotifications = res.items;
          this.totalPushNotifications = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
      });
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.getPushNotificationList(this.currentPage, this.pageSize);
    }
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSize = size;
    this.currentPage = 1;
    this.getPushNotificationList(this.currentPage, this.pageSize);
  }

  navigateToEdit(notification: any) {
    this.router.navigate(
      ['/notification-contents/push/edit', notification.id],
      {
        state: { notification },
      }
    );
  }

  getLanguageText(code: string): string {
    if (code === 'en') return 'English';
    else if (code === 'nl') return 'Dutch';
    else return 'Unknown';
  }
}
